import { ConfigProvider } from "antd";
import esES from "antd/locale/es_ES";
import { BrowserRouter } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import { Toaster } from "sileo";
import "sileo/styles.css";

import { AppRouter } from "./router";
import { sushi2goTheme } from "./shared/theme/antdTheme";

const GlobalStyle = createGlobalStyle`
  :root {
    --primary: #E95735;
    --primary-light: #fff4f0;
    --primary-hover: #d44a2c;
    --accent: #E95735;

    --font-size-xlarge: 32px;
    --font-size-large: 28px;
    --font-size-medium: 20px;
    --font-size-small: 18px;
    --font-size-tiny: 16px;

    --gray-50: #f8fafc;
    --gray-100: #f1f5f9;
    --gray-200: #e2e8f0;
    --gray-300: #cbd5e1;
    --gray-400: #94a3b8;
    --gray-500: #64748b;
    --gray-600: #475569;
    --gray-700: #334155;
    --gray-800: #1e293b;
    --gray-900: #0f172a;

    --shadow-sm: 0 1px 2px rgba(15, 23, 42, 0.05);
    --shadow-md: 0 4px 12px rgba(15, 23, 42, 0.08);
    --shadow-lg: 0 8px 24px rgba(15, 23, 42, 0.12);

    --radius-sm: 8px;
    --radius-md: 10px;
    --radius-lg: 14px;
    --radius-xl: 16px;
  }

  *, *::before, *::after {
    box-sizing: border-box;
  }

  html, body, #root {
    margin: 0;
    padding: 0;
    min-height: 100vh;
    width: 100%;
    scrollbar-gutter: stable;
  }

  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    color: var(--gray-800);
    background-color: var(--gray-50);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  ::selection {
    background: rgba(233, 87, 53, 0.2);
    color: var(--gray-900);
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: var(--gray-300);
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: var(--gray-400);
  }

  /* Sileo por encima de Drawer/Modal de Ant Design (z-index 1000) */
  [data-sileo-viewport] {
    z-index: 1100 !important;
  }

  /* Sileo: sin capitalize por palabra (mensajes en español) */
  [data-sileo-title] {
    text-transform: none;
  }
`;

function App() {
  return (
    <ConfigProvider locale={esES} theme={sushi2goTheme}>
      <BrowserRouter>
        <GlobalStyle />
        <Toaster
          position="top-center"
          theme="light"
          options={{
            roundness: 16,
          }}
        />
        <AppRouter />
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
